import * as fromActionTypes from 'store/actionTypes/debug';

export const setShowTranslationKeys = (toggle) => ({
  type: fromActionTypes.DEBUG_SET_SHOW_TRANSLATION_KEYS,
  payload: toggle,
});
